import { useState } from 'react';

export default function WhatsAppButton() {
  const [showTooltip, setShowTooltip] = useState(false);
  const whatsappNumber = "5555992338351";
  const whatsappMessage = encodeURIComponent("Olá! Acabei de acessar o seu site e me interessei. Gostaria de agendar uma consulta.");

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute right-16 bottom-2 bg-white border border-[#e8dfc8] text-[#333] text-xs px-3 py-2 rounded-xl whitespace-nowrap shadow-xl" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          Fale conosco agora
        </div>
      )}

      {/* Button */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        onclick="return gtag_report_conversion('https://wa.me/5555992338351');"
        rel="noopener noreferrer"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] rounded-full shadow-2xl hover:scale-110 transition-all duration-300 cursor-pointer"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-fill text-white text-2xl"></i>
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></span>
      </a>
    </div>
  );
}
